import { Markdown } from "../../misc/Markdown";
import { isPublishable, type LegalDoc } from "./legalDocs";

/**
 * Página pública de un texto legal (sin login, legible en celular). Con marcadores {{ }} sin
 * llenar solo dice "En preparación": nunca se exponen los marcadores.
 */
export const LegalPage = ({ doc }: { doc: LegalDoc }) => (
  <main className="mx-auto max-w-3xl p-4 pb-16 text-sm leading-relaxed">
    {isPublishable(doc.md) ? (
      <Markdown className="[&_p]:leading-relaxed [&_h1]:text-2xl [&_h3]:text-base [&_table]:block [&_table]:overflow-x-auto [&_th]:px-2 [&_td]:px-2">
        {doc.md}
      </Markdown>
    ) : (
      <>
        <h1 className="text-2xl font-bold">{doc.label}</h1>
        <p className="mt-3 text-muted-foreground">En preparación.</p>
      </>
    )}
  </main>
);
